<template>
  <Modal
    v-model="_value"
    width="700"
    title="JT808批量设置终端参数设置"
    ok-text="发送"
    @on-ok="onOk">

    <div class="demo-split">
      <Split v-model="split3">
        <div slot="left" class="demo-split-pane no-padding">
          <Split v-model="split4" mode="vertical">
            <div slot="top" class="demo-split-pane">
<!--              Top Pane-->
              <Input size="small" v-model="terminalNum" placeholder="请输入主机号" clearable style="width: 120px" />
              <Button size="small" type="primary" style="margin-left: 5px" @click="onfind">搜索</Button>
            </div>
            <div slot="bottom" class="demo-split-pane" :style="treeStyle">
<!--              Bottom Pane-->
              <Tree size="small" ref="tree" :data="groupVehicleInfoTree" :render="renderContent"
                    show-checkbox class="demo-tree-render" :load-data="onLoadChildrenGroupData"
                    @on-check-change="onTreeCheckChange"></Tree>

            </div>
          </Split>
        </div>
        <div slot="right" class="demo-split-pane">
<!--          Right Pane-->
              <div style="position:relative;">
                <span>主机号：{{jt808terminalNum}}</span>
              <Table :columns="columns" :data="data" height="350" size="small">
                <template slot-scope="{ row, index }" slot="parameterdata">
                  <Input  size="small" type="text" v-model="editparameterdata" v-if="editIndex === index" />
                  <span v-else>{{ row.parameterdata }}</span>
                </template>
                <template slot-scope="{ row, index }" slot="action">
                  <div v-if="editIndex === index">
                    <Button size="small" type="primary" @click="handleSave(index)">保存</Button>
                    <Button size="small" type="error" @click="editIndex = -1">取消</Button>
                  </div>
                  <div v-else>
                    <Button size="small" type="primary" @click="handleEdit(row, index)">操作</Button>
                  </div>
                </template>
              </Table>
              <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                                      align-items: center;
                                      justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
                <Spin size="large"></Spin>
                <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
              </div>
              </div>
        </div>
      </Split>
    </div>

  </Modal>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { genURLParams } from '@/libs/urlparamhelper'

export default {
  name: 'jt808-set-parameterdata-modal',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      split3: 0.4,
      split4: 0.2,

      terminalNum: null,
      jt808terminalNum: null,
      jt808ID: null,

      data: [],
      listLoadding: false,

      jt808ParameterDataList: null,
      jt808List: [],

      columns: [
        // {
        //   title: 'id',
        //   resizable: true,
        //   key: 'id',
        //   tooltip: 'true',
        //   width: 50
        // },
        {
          title: '参数名称',
          resizable: true,
          key: 'parametername',
          ellipsis: 'true',
          width: 180
        },
        {
          title: '数值',
          resizable: true,
          key: 'parameterdata',
          ellipsis: 'true',
          width: 100,
          slot: 'parameterdata'
        },
        // {
        //   title: '更新时间',
        //   resizable: true,
        //   key: 'updateDatetime',
        //   ellipsis: 'true',
        //   width: 180,
        //   render: function (h, params) {
        //     if (params.row.updateDatetime) {
        //       let d = new Date(params.row.updateDatetime)
        //       return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
        //     }
        //   }
        // },
        {
          title: '操作',
          width: 80,
          slot: 'action'
        }
      ],
      editIndex: -1, // 当前聚焦的输入框的行数
      editparameterdata: '', // 第一列输入框，当然聚焦的输入框的输入内容，与 data 分离避免重构的闪烁

      treeStyle: {
        'padding-left': '20px',
        'background-color': '#ffff',
        height: '100%',
        overflow: 'auto'
      },
      // 树结构数据
      groupVehicleInfoTree: [{
        title: '所有车辆',
        expand: true,
        isGroup: true,
        children: [
          {
            title: '挂载车辆',
            expand: false,
            loading: false,
            isGroup: true,
            children: []
          },
          {
            title: '挂载分组',
            expand: false,
            loading: false,
            isGroup: true,
            children: []
          }
        ]
      }]
    }
  },
  methods: {
    ...mapActions([
      'Jt808DeviceServ_ResetAllReportInterval'
    ]),
    onOk () {
      console.log(this.jt808List)
      store.dispatch('Jt808ParameterDataServ_BatchUploadJt808ParameterData', {
        params: {
          jt808parameterdatalist: this.jt808ParameterDataList,
          terminalNumlist: this.jt808List
        },
        urlparams: null
      }).then(() => {
        this.setPage()
      }).catch(err => {
        this.$Message.error(err)
      })
    },

    handleEdit (row, index) {
      this.editparameterdata = row.parameterdata
      this.editIndex = index
    },
    handleSave (index) {
      this.data[index].parameterdata = this.editparameterdata
      this.editIndex = -1

      store.dispatch('Jt808ParameterDataServ_ModifyObj', {
        params:
            this.data[index],
        urlparams: null
      }).then(() => {
        this.setPage()
      }).catch(err => {
        this.$Message.error(err)
      })
    },

    setPage () {
      this.listLoadding = true
      let queryParams = []
      queryParams.push(genQueryParam('jt808deviceid', 'EQ', this.jt808ID))
      store.dispatch('Jt808ParameterDataServ_GetAll', {
        params: null,
        urlparams: {
          q: queryParams
        }
      }).then(() => {
        this.data = store.getters.get_Jt808ParameterData_GetAllResult
        this.jt808ParameterDataList = store.getters.get_Jt808ParameterData_GetAllResult
        this.listLoadding = false
      }).catch(err => {
        this.$Message.error(err)
        this.listLoadding = false
      })
    },

    onfind () {
      this.listLoadding = true

      let jt80queryParams = []
      jt80queryParams.push(genQueryParam('terminalNum', 'EQ', this.terminalNum))
      store.dispatch('Jt808DeviceServ_GetPage', {
        params: null,
        urlparams: {
          q: jt80queryParams
        }
      }).then(() => {
        console.log(store.getters.get_Jt808Device_GetPageResult.content[0])

        this.jt808terminalNum = store.getters.get_Jt808Device_GetPageResult.content[0].terminalNum
        this.jt808ID = store.getters.get_Jt808Device_GetPageResult.content[0].id
        let queryParams = []
        queryParams.push(genQueryParam('jt808deviceid', 'EQ', this.jt808ID))
        store.dispatch('Jt808ParameterDataServ_GetAll', {
          params: null,
          urlparams: {
            q: queryParams
          }
        }).then(() => {
          this.data = store.getters.get_Jt808ParameterData_GetAllResult
          this.jt808ParameterDataList = store.getters.get_Jt808ParameterData_GetAllResult
          this.listLoadding = false
        }).catch(err => {
          this.$Message.error(err)
          this.listLoadding = false
        })
      }).catch(err => {
      })
    },

    /**
       * 加载子节点回调函数
       * @param item
       * @param callback
       */
    onLoadChildrenGroupData (item, callback) {
      let tempData = []
      if (item.title === '挂载车辆') {
        store.dispatch('VehicleInfoServ_GetDirectlyUnderBindAll', {
          parmas: null,
          urlparmas: null
        }).then(() => {
          if (store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult && item.children.length == 0) {
            store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult.forEach(vehicleInfoItem => {
              if (vehicleInfoItem.positioningDeviceInfos) {
                item.children.push(
                  {
                    id: vehicleInfoItem.id,
                    title: vehicleInfoItem.registrationNum,
                    expand: false,
                    // loading: false,
                    // children: [],
                    isGroup: false,
                    parent: item,
                    terminalNum: vehicleInfoItem.positioningDeviceInfos[0].terminalNum
                  }
                )
              } else {
                item.children.push(
                  {
                    id: vehicleInfoItem.id,
                    title: vehicleInfoItem.registrationNum,
                    expand: false,
                    // loading: false,
                    // children: [],
                    isGroup: false,
                    parent: item,
                    terminalNum: null
                  }
                )
              }
            })
          }
        }).catch(err => {
          this.$Message.error(err)
          console.log(err)
        })
        callback(tempData)
      } else if (item.title === '挂载分组') {
        store.dispatch('VehicleInfoGroupServ_GetDirectlyUnderBindAll', {
          params: null,
          urlparams: null
        }).then(() => {
          if (store.getters.get_VehicleInfoGroup_GetDirectlyUnderBindAllResult) {
            store.getters.get_VehicleInfoGroup_GetDirectlyUnderBindAllResult.forEach(vehicleInfoGroupItem => {
              tempData.push(
                {
                  id: vehicleInfoGroupItem.id,
                  title: vehicleInfoGroupItem.name,
                  expand: false,
                  loading: false,
                  children: [],
                  isGroup: true,
                  parent: item,
                  terminalNum: null
                }
              )
            })
            callback(tempData)
          }
        }).catch(err => {
          this.$Message.error(err)
          console.log(err)
        })
      } else {
        // 先加载子组
        console.log('加载子组')
        store.dispatch('VehicleInfoGroupServ_GetChildrenGroups', {
          params: { id: item.id },
          urlparams: null
        }).then(() => {
          console.log(store.getters.get_VehicleInfoGroup_GetChildrenGroupsResult)
          if (store.getters.get_VehicleInfoGroup_GetChildrenGroupsResult.length > 0) {
            store.dispatch('VehicleInfoServ_GetByGroupId', {
              params: {
                id: item.id
              },
              urlparmas: null
            }).then(() => {
              console.log(store.getters.get_VehicleInfo_GetByGroupIdResult)
              console.log(item)
              if (store.getters.get_VehicleInfo_GetByGroupIdResult) {
                store.getters.get_VehicleInfo_GetByGroupIdResult.forEach(vehicleinfo => {
                  console.log(vehicleinfo.positioningDeviceInfos)
                  if (vehicleinfo.positioningDeviceInfos != null) {
                    tempData.push(
                      {
                        id: vehicleinfo.id,
                        title: vehicleinfo.registrationNum,
                        expand: false,
                        // loading: false,
                        // children: [],
                        isGroup: false,
                        parent: item,
                        terminalNum: vehicleinfo.positioningDeviceInfos[0].terminalNum
                      }
                    )
                  } else {
                    tempData.push(
                      {
                        id: vehicleinfo.id,
                        title: vehicleinfo.registrationNum,
                        expand: false,
                        // loading: false,
                        // children: [],
                        isGroup: false,
                        parent: item,
                        terminalNum: null
                      }
                    )
                  }
                })
              }
              callback(tempData)
            }).catch(err => {
              this.$Message.error(err)
              console.log(err)
            })
            store.getters.get_VehicleInfoGroup_GetChildrenGroupsResult.forEach(vehicleInfoGroupItem => {
              tempData.push(
                {
                  id: vehicleInfoGroupItem.id,
                  title: vehicleInfoGroupItem.name,
                  expand: false,
                  loading: false,
                  children: [],
                  isGroup: true,
                  parent: item,
                  terminalNum: null
                }
              )
            })
            // callback(tempData)
          } else {
            store.dispatch('VehicleInfoServ_GetByGroupId', {
              params: {
                id: item.id
              },
              urlparmas: null
            }).then(() => {
              if (store.getters.get_VehicleInfo_GetByGroupIdResult) {
                store.getters.get_VehicleInfo_GetByGroupIdResult.forEach(vehicleinfo => {
                  // console.log(vehicleinfo)
                  if (vehicleinfo.positioningDeviceInfos) {
                    tempData.push(
                      {
                        id: vehicleinfo.id,
                        title: vehicleinfo.registrationNum,
                        expand: false,
                        // loading: false,
                        // children: [],
                        isGroup: false,
                        parent: item,
                        terminalNum: vehicleinfo.positioningDeviceInfos[0].terminalNum
                      }
                    )
                  } else {
                    tempData.push(
                      {
                        id: vehicleinfo.id,
                        title: vehicleinfo.registrationNum,
                        expand: false,
                        // loading: false,
                        // children: [],
                        isGroup: false,
                        parent: item,
                        terminalNum: null
                      }
                    )
                  }
                })
              }
              callback(tempData)
            }).catch(err => {
              this.$Message.error(err)
              console.log(err)
            })
          }
        }).catch(err => {
          this.$Message.error(err)
          console.log(err)
        })
      }
    },

    onTreeCheckChange (selectArray) {
      console.log(selectArray)
      this.jt808List = []
      if (selectArray.length > 0) {
        selectArray.forEach(selectArrayindex => {
          if (selectArrayindex.title === '挂载分组') {
            console.log('加载挂载分组')

            // 订阅全部分组车辆
            store.dispatch('VehicleInfoGroupServ_GetDirectlyUnderBindAll', {
              params: null,
              urlparams: null
            }).then(res => {
              // 订阅列表
              // console.log(res)
              if (store.getters.get_VehicleInfoGroup_GetDirectlyUnderBindAllResult) {
                store.getters.get_VehicleInfoGroup_GetDirectlyUnderBindAllResult.forEach(vehiclegroup => {
                  store.dispatch('VehicleInfoServ_GetGroupRecursiveAll', {
                    params: {
                      groupId: vehiclegroup.id
                    },
                    urlparams: null
                  }).then(() => {
                    if (store.getters.get_VehicleInfo_GetGroupRecursiveAllResult) {
                      store.getters.get_VehicleInfo_GetGroupRecursiveAllResult.forEach(vehicle => {
                        if (vehicle.positioningDeviceInfos) {
                          // 订阅列表
                          vehicle.positioningDeviceInfos.forEach(terminalNum => {
                            this.jt808List.push(terminalNum.terminalNum)
                          })
                        }
                      })
                    }
                  }).catch(err => {
                    console.log(err)
                  })
                })
              }
            }).catch(err => {
              console.log(err)
            })
          } else if (selectArrayindex.title === '挂载车辆') {
            console.log('加载挂载车辆')
            store.dispatch('VehicleInfoServ_GetDirectlyUnderBindAll', {
              params: null,
              urlparams: null
            }).then(() => {
              // console.log(store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult)
              // this.vehicleDymaicManager.putVehicleInfo(store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult)
              if (store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult) {
                store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult.forEach(vehicle => {
                  // console.log(vehicle)
                  if (vehicle.positioningDeviceInfos) {
                    // 订阅列表
                    vehicle.positioningDeviceInfos.forEach(terminalNum => {
                      this.jt808List.push(terminalNum.terminalNum)
                    })
                  }
                })
              }
            }).catch(err => {
              this.$Message.error(err)
              console.log(err)
            })
          } else if (selectArrayindex.title === '所有车辆') {
            console.log('加载所有车辆')

            store.dispatch('VehicleInfoServ_GetBindAll', {
              params: null,
              urlparams: null
            }).then(() => {
              // console.log(store.getters.get_VehicleInfo_GetBindAllResult)
              // this.vehicleDymaicManager.putVehicleInfo(store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult)
              if (store.getters.get_VehicleInfo_GetBindAllResult) {
                store.getters.get_VehicleInfo_GetBindAllResult.forEach(vehicle => {
                  // console.log(vehicle)
                  if (vehicle.positioningDeviceInfos) {
                    // 订阅列表
                    vehicle.positioningDeviceInfos.forEach(terminalNum => {
                      this.jt808List.push(terminalNum.terminalNum)
                    })
                  }
                })
              }
            }).catch(err => {
              this.$Message.error(err)
              console.log(err)
            })
          } else {
            if (selectArrayindex.isGroup) {
              store.dispatch('VehicleInfoServ_GetGroupRecursiveAll', {
                params: {
                  groupId: selectArrayindex.id
                },
                urlparams: null
              }).then(() => {
                if (store.getters.get_VehicleInfo_GetGroupRecursiveAllResult) {
                  store.getters.get_VehicleInfo_GetGroupRecursiveAllResult.forEach(vehicle => {
                    if (vehicle.positioningDeviceInfos) {
                      // 订阅列表
                      vehicle.positioningDeviceInfos.forEach(terminalNum => {
                        this.jt808List.push(terminalNum.terminalNum)
                      })
                    }
                  })
                }
              }).catch(err => {
                this.$Message.error(err)
                console.log(err)
              })
            } else {
              store.dispatch('VehicleInfoServ_GetDetail', {
                params: {
                  id: selectArrayindex.id
                },
                urlparams: null
              }).then(() => {
                // console.log(store.getters.get_VehicleInfo_GetDetailResult)
                if (store.getters.get_VehicleInfo_GetDetailResult) {
                  if (store.getters.get_VehicleInfo_GetDetailResult.positioningDeviceInfos) {
                    // this.jt808List.push(store.getters.get_VehicleInfo_GetDetailResult)
                    store.getters.get_VehicleInfo_GetDetailResult.positioningDeviceInfos.forEach(terminalNum => {
                      this.jt808List.push(terminalNum.terminalNum)
                    })
                  }
                }
              }).catch(err => {
                console.log(err)
              })
            }
          }
        })
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    totalElements () {
      if (store.getters.get_Jt808ParameterData_GetPageResult) {
        return store.getters.get_Jt808ParameterData_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    pageSize () {
      if (store.getters.get_Jt808ParameterData_GetPageResult) {
        return store.getters.get_Jt808ParameterData_GetPageResult.size
      } else {
        return 0
      }
    }

  },
  mounted () {
    this.$nextTick(() => {
      store.dispatch('VehicleInfoGroupServ_GetDirectlyUnderBindAll', {
        params: null,
        urlparams: null
      }).then(res => {
        console.log(res)
      }).catch(err => {
        this.$Message.error(err)
        console.log(err)
      })
    })
  }
}
</script>

<style scoped>
  .demo-split{
    height: 400px;
    border: 1px solid #dcdee2;
  }
  .demo-split-pane{
    padding: 10px;
  }
  .demo-split-pane.no-padding{
    height: 400px;
    padding: 0;
  }
</style>
